import React from "react";
import * as d3 from "d3";

export const parseSystemDate = (input) => new Date(input);

export const fixedPrecision = (value, decimals = 4) =>
  parseFloat(value.toFixed(decimals));

export const parseFloatOrNull = (value) =>
  value === "n/a"
    ? null
    : value.endsWith("%") === true
    ? parseFloat((parseFloat(value.trim("%")) / 100).toFixed(4))
    : parseFloat(value);

const dateTimeParser = d3.timeParse("%Y-%m-%dT%H:%M:%S");

const capitalizeFirstLetter = (word) =>
  word[0].toUpperCase() + word.slice(1).toLowerCase();

const lowerFirstUpperOthers = (word, index) =>
  index === 0 ? word.toLowerCase() : capitalizeFirstLetter(word);

const asJSAttribute = (input) =>
  input
    .split(/[\s-]+/)
    .map(lowerFirstUpperOthers)
    .join("");

const timeAndNumbers = (row, keys, skipped = []) =>
  row
    .split(/\s+/)
    .map((value, index) =>
      skipped.length > 0 && skipped.includes(keys[index])
        ? null
        : [
            keys[index],
            index > 0 ? parseFloatOrNull(value) : dateTimeParser(value),
          ]
    )
    .filter((item) => item !== null);

export const parseTrafficCongestion = (input) => {
  const [head, ...rows] = input.trim("\n").split("\n");
  const translations = {
    "BYTES-DN-NEAR-LIMIT-%": "near",
    "BYTES-DN-CONGESTED-%": "congested",
    "BYTES-DN-ACM-ACTIVE-%": "acm",
  };
  const skipped = [
    "REDUCTION-RTT-MS",
    "",
    "REDUCTION-RTX-%",
    "REDUCTION-SPEED-%",
  ];
  const keys = head
    .split(/\s+/)
    .map((key) =>
      skipped.includes(key) ? key : translations[key] || asJSAttribute(key)
    );
  return {
    items: rows.map((row) =>
      Object.fromEntries(timeAndNumbers(row, keys, skipped))
    ),
  };
};

export const parseLatencyReduction = (input) => {
  const [head, ...rows] = input.trim("\n").split("\n");
  const translations = {
    "REDUCTION-RTT-MS": "reduction",
  };
  const skipped = [
    "BYTES-DN-NEAR-LIMIT-%",
    "BYTES-DN-CONGESTED-%",
    "BYTES-DN-ACM-ACTIVE-%",
    "REDUCTION-RTX-%",
    "REDUCTION-SPEED-%",
  ];
  const keys = head
    .split(/\s+/)
    .map((key) =>
      skipped.includes(key) ? key : translations[key] || asJSAttribute(key)
    );
  return rows.map((row) =>
    Object.fromEntries(timeAndNumbers(row, keys, skipped))
  );
};

export const parseRetransmissionsReduction = (input) => {
  const [head, ...rows] = input.trim("\n").split("\n");
  const translations = {
    "REDUCTION-RTX-%": "reduction",
  };
  const skipped = [
    "BYTES-DN-NEAR-LIMIT-%",
    "BYTES-DN-CONGESTED-%",
    "BYTES-DN-ACM-ACTIVE-%",
    "REDUCTION-RTT-MS",
    "REDUCTION-SPEED-%",
  ];
  const keys = head
    .split(/\s+/)
    .map((key) =>
      skipped.includes(key) ? key : translations[key] || asJSAttribute(key)
    );
  return rows.map((row) =>
    Object.fromEntries(timeAndNumbers(row, keys, skipped))
  );
};

const parseDate = d3.timeParse("%Y-%m-%dT%H:%M:%S");

function getKeysSeries(header) {
  const [, ...keys] = header.split(/\s+/);
  return keys.map((key) => {
    const chunks = key.split("-").map((item) => {
      return item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
    });
    return chunks.join("-");
  });
}

export function parseStatsThrougputData(response) {
  const lines = response.trim().split("\n");
  const linesSplitted = lines.reduce((acc, line)=>{
    if(line.includes('Access') || line.includes('Internet')){
     acc.responseBlock = acc.responseBlock + 1;
    }
    if(!acc.responses[acc.responseBlock]){
      acc.responses[acc.responseBlock] = [line];
    } else {
      acc.responses[acc.responseBlock].push(line);
    }
    return acc;
  }, {responseBlock: -1, responses:[]});

  let newRows = [];
  for (let i = 0; i < linesSplitted.responses.length; i++) {
    const response = linesSplitted.responses[i];
    const [headerInterface, header, ...rows] =response;
    const headerInterfaceAttrs = headerInterface.trim().split(/\s+/);
    const internetIndex = headerInterfaceAttrs.findIndex((el => el === "Internet"));
    const accessIndex = headerInterfaceAttrs.findIndex((el => el === "Access"));
    const newRowsBlock = rows.reduce((acc, row)=>{
      const [timeAt, ...attrs ] = row.trim().split(/\s+/);
      const time = parseDate(timeAt);
  
      if(time !== null){
        const newItem = attrs.reduce((accItem, value, index)=> {
          if(index===internetIndex*2){
            accItem["Up"] = value === "n/a" ? null : Number(value);
          }
          if(index===accessIndex*2){
            accItem["Dn"] =value === "n/a" ? null : Number(value);
          }
          return accItem;
        }, {time})
        acc.push(newItem);
      }
      return acc;
    }, []);
    newRows = newRows.concat(newRowsBlock);
  }

  return { items: newRows };
}